import { TextField } from './text-field';
import { ReactNode } from 'react';

type RecallCodeFieldProps = {
  label?: ReactNode;
  required?: boolean;
  isSmallSize?: boolean;
};

export const RecallCodeField = ({
  label = 'Recall Code',
  required = false,
  isSmallSize = false
}: RecallCodeFieldProps) => {
  return <TextField name="code" label={label} required={required} isSmallSize={isSmallSize} />;
};
